import { FormErrorMessage, Input, Switch } from "@chakra-ui/react";
import CardFormAlt from "../CardFormAlt";
import ResponsiveFormControl from "../ResponsiveFormControl";
import { ModalContent } from "../FullWidthModal";
import { InheritModalContentProps } from "../FullWidthModal/interface";
import { CreateUpdatePaymentDetailInput } from "../../generated/graphql";
import { Controller } from "react-hook-form";

const MCFormPaymentDetail: React.FC<
  InheritModalContentProps<CreateUpdatePaymentDetailInput>
> = ({ ...props }) => {
  return (
    <ModalContent
      defaultValues={{
        enable: true,
      }}
      {...props}
    >
      {({ register, errors, control }) => {
        return (
          <form autoComplete="off">
            <CardFormAlt
              boxShadow="rgba(0, 0, 0, 0.04) 0px 1px 4px"
              borderRadius="8px"
              padding="26px 24px"
              title="Payment Detail"
              mb={10}
            >
              <ResponsiveFormControl
                label="Company Name"
                isRequired
                isInvalid={errors.companyName ? true : false}
                messageComponents={
                  <FormErrorMessage>Company Name is required!</FormErrorMessage>
                }
              >
                <Input {...register("companyName", { required: true })} />
              </ResponsiveFormControl>
              <ResponsiveFormControl
                label="Branch Name"
                isRequired
                isInvalid={errors.branchName ? true : false}
                messageComponents={
                  <FormErrorMessage>Branch Name is required!</FormErrorMessage>
                }
              >
                <Input {...register("branchName", { required: true })} />
              </ResponsiveFormControl>
              <ResponsiveFormControl
                label="Bank No"
                isRequired
                isInvalid={errors.bankNo ? true : false}
                messageComponents={
                  <FormErrorMessage>Bank No is required!</FormErrorMessage>
                }
              >
                <Input {...register("bankNo", { required: true })} />
              </ResponsiveFormControl>
              <ResponsiveFormControl
                label="Swift Code"
                isRequired
                isInvalid={errors.swiftCode ? true : false}
                messageComponents={
                  <FormErrorMessage>Swift Code is required!</FormErrorMessage>
                }
              >
                <Input {...register("swiftCode", { required: true })} />
              </ResponsiveFormControl>
              <ResponsiveFormControl
                label="Account No."
                isRequired
                isInvalid={errors.accountNo ? true : false}
                messageComponents={
                  <FormErrorMessage>Account No is required!</FormErrorMessage>
                }
              >
                <Input {...register("accountNo", { required: true })} />
              </ResponsiveFormControl>

              <ResponsiveFormControl label="Enable">
                <Controller
                  render={({ field: { value, onChange } }) => (
                    <Switch onChange={onChange} isChecked={value} />
                  )}
                  name="enable"
                  control={control}
                />
              </ResponsiveFormControl>
            </CardFormAlt>
          </form>
        );
      }}
    </ModalContent>
  );
};

export default MCFormPaymentDetail;
